import { ColorPicker } from "../../../../../../editComponents/form/ColorPicker/ColorPicker";
import { Switch } from "../../../../../../editComponents/form/Switch/Switch";
import { IColor } from "../../../../../../interfaces/Site";
import { IColorOverride } from "../../../../interfaces/IColorOverride";
import styles from "./EventLogoColorPicker.module.scss";

interface IProps {
    value: IColorOverride;
    handleChange: (value: IColorOverride) => void;
    colorLabel: "textfärg" | "bakgrundsfärg";
    id: string;
}

export function EventLogoColorPicker(props: IProps) {
    const setOverride = (override: boolean) => {
        props.handleChange({
            ...props.value,
            override,
        });
    };

    const setColor = (color: IColor) => {
        props.handleChange({
            ...props.value,
            color,
        });
    };


    const colorValue = props.value.color ? props.value.color : { h: 255, s: 255, l: 255, a: 1 };
    return (
        <>
            <div className={styles.wrapper}>
                <div>
                    <Switch
                        label={"Ändra " + props.colorLabel + " "}
                        name={"overrideColor" + props.id}
                        handleChange={setOverride}
                        value={props.value.override}
                        id={"overrideColor" + props.id}
                        labelPosition="RIGHT"
                    />
                </div>
                {props.value.override ? (
                    <div>
                        <ColorPicker
                            value={colorValue}
                            handleChange={setColor}
                            name={"eventLogoOverrideColor" + props.id}
                            id={"eventLogoOverrideColor" + props.id}
                            disableAlpha={true}
                            pickerPosition="LEFT"
                        />
                    </div>
                ) : null}
            </div>
        </>
    );
}
